import React, { useEffect, useState } from "react";
import { KnowledgeCenterComponent } from '@src/CommonComponents/knowledgeCenterModal/knowledgeCenter';
import { metricDefinitions } from "@src/apps/Header/Main/Main.service";
import APP_CONSTANT from '@src/apps/Header/Main/constant';

const KnowledgeCenterCallWrapper = (props) => {
    useEffect(() => { getMetricsData() }, []);

    const [knowledgeCenterData, setknowledgeCenterData] = useState<{ isOpen: boolean, metricData: any, glossaryList: any[], onboardingKCList: any[] }>
        ({ isOpen: false, metricData: {}, glossaryList: [], onboardingKCList: APP_CONSTANT.ONBOARDING_KC_LIST });
    const getMetricsData = async () => {
        const response = await metricDefinitions();
        if (response?.StatusCode === 200)
            setknowledgeCenterData({ ...knowledgeCenterData, isOpen: false, glossaryList: response?.Data });
    };
    const emithandleIconClick = async (metricData?: any) => {
        setknowledgeCenterData({ ...knowledgeCenterData, metricData, isOpen: true });
    };
    const closeKCIconClick = async () => {
        setknowledgeCenterData({ ...knowledgeCenterData, metricData: {}, isOpen: false });
    };

    return (<>
        <div onClick={() => emithandleIconClick({ metricId: props?.metricId, title: props?.title })}>
            {props.children}
        </div>
        <KnowledgeCenterComponent  {...knowledgeCenterData} onCloseKc={closeKCIconClick} />
    </>);
};
export default KnowledgeCenterCallWrapper;